<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="1095px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner charge-scheme-batch-dialog"
  >
    <div class="app-main-inner-row">
      <el-form
        label-width="125px"
        label-position="left"
      >
        <el-row v-if="!saleRoleHide" :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_ProductName')">
              <el-input v-model="form.schemeName" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
              <cargo-sales-company-select
                options-width="150px;"
                :disabled="chkMatch"
                :method-params="{customer:true}"
                :clear-not-match="true"
                :default-value="form.customer == 0 ? '': form.customer"
                @parentCallBack="p=>form.customer=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_BookingAgent')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :disabled="chkMatch"
                :method-params="{bookingAgent:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="form.bookingAgent == 0 ? '': form.bookingAgent"
                @parentCallBack="p=>form.bookingAgent=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!saleRoleHide" :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_Carrier')">
              <cargo-advance-select
                v-show="isSea"
                :disabled="chkMatch"
                filterable
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                :default-value="form.seCarrier == 0 ? '': form.seCarrier"
                @parentCallBack="p=>form.seCarrier=p.cmpIdx"
              />
              <cargo-advance-select
                v-show="!isSea"
                :disabled="chkMatch"
                filterable
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                :default-value="form.aiCarrier == 0 ? '': form.aiCarrier"
                @parentCallBack="p=>form.aiCarrier=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_FLCLType')">
              <el-select
                v-model="form.containerLoadType"
                :disabled="chkMatch"
              >
                <el-option
                  v-for="(item,index) in containerLoadTypes"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_CargoType')">
              <cargo-advance-select
                filterable
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_CargoType"
                callback-method-type="value"
                :default-value="form.cargoType"
                :callback-params="{key:'cargoType'}"
                options-width="150px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!saleRoleHide" :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.PortOfLoading')">
              <cargo-advance-select
                v-show="isSea"
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.txtSeaLoadingPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtSeaLoadingPort=p.code}"
              />

              <cargo-advance-select
                v-show="!isSea"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                options-width="150px;"
                :default-value="form.txtAirLoadingPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtAirLoadingPort=p.code}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
              <cargo-advance-select
                v-show="isSea"
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.txtSeaDestinationPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtSeaDestinationPort=p.code}"
              />

              <cargo-advance-select
                v-show="!isSea"
                :disabled="chkMatch"
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                :default-value="form.txtAirDestinationPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtAirDestinationPort=p.code}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_DestinationAgent')">
              <cargo-advance-select
                filterable
                :disabled="chkMatch"
                tag-name="englishName"
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{overseaAgent:true}"
                :default-value="form.txtDestAgent == 0 ? '': form.txtDestAgent"
                @parentCallBack="p=>form.txtDestAgent=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!saleRoleHide" :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_Airline')">
              <cargo-advance-select
                filterable
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Region"
                :callback-params="{key:'txtServiceLine'}"
                callback-method-type="value"
                options-width="150px;"
                :default-value="form.txtServiceLine"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="job && job.fba" :span="8">
            <el-form-item :label="$t('SeaExport.FeeName')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_ChargeItem"
                :default-value="form.chargeItemId === 0 ? '': form.chargeItemId"
                @parentCallBack="p=>form.chargeItemId=p.itemId"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="source==='tabCharges'" :span="8">
            <el-form-item :label="$t('Pricing.BeginDate')">
              <div style="display: flex;justify-content: space-between">
                <el-date-picker
                  v-model="form.effectiveDateStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                />
                <span style="font-size: 12px;margin-left: 1px;margin-right: 1px;">-</span>
                <el-date-picker
                  v-model="form.effectiveDateEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.NominatedAgent')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{designationAgent:true, active: true}"
                :default-value="form.txtNominatedAgent == 0 ? '': form.txtNominatedAgent"
                @parentCallBack="p=>form.txtNominatedAgent=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="source!=='tabCharges'" :span="8">
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true, active: true}"
                :default-value="form.txtExchangeAgent == 0 ? '': form.txtExchangeAgent"
                @parentCallBack="p=>form.txtExchangeAgent=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!saleRoleHide" :gutter="10">
          <el-col :span="8">
            <el-form-item v-if="source==='operateBillDialog'" :label="$t('CargoMsg.Cargo_PaymentReceiveMethod')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :disabled="receivableDisable"
                :select-type="selectTypeNames.local_cache_ChangeChargeConstant$CHANGE_CHARGE_CHARGETYPE"
                :default-value="form.receivable"
                @parentCallBack="p=>form.receivable=p.value"
              />
            </el-form-item>
            <el-form-item v-if="source==='tabCharges'" :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true, active: true}"
                :default-value="form.txtExchangeAgent == 0 ? '': form.txtExchangeAgent"
                @parentCallBack="p=>form.txtExchangeAgent=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="source!=='tabCharges' && source!=='operateBillDialog' ? 8 : 0">
            <el-form-item label=" ">
              <div style="display: flex;justify-content: space-between">
                <el-checkbox
                  v-show="source !== 'jobList'"
                  v-model="chkMatch"
                  @change="chkMatch_changeHandler"
                >{{ $t('SeaExport.Autowire') }}</el-checkbox>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="custom"
            >
              <el-button
                type="primary"
                @click="toQuery(1)"
              >{{ $t('common.btn.query') }}</el-button>
              <el-button
                type="primary"
                @click="resetHandler"
              >{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="saleRoleHide" :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_ProductName')">
              <el-input v-model="form.schemeName" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
              <cargo-sales-company-select
                options-width="150px;"
                :disabled="chkMatch"
                :method-params="{customer:true}"
                :clear-not-match="true"
                :default-value="form.customer == 0 ? '': form.customer"
                @parentCallBack="p=>form.customer=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_Carrier')">
              <cargo-advance-select
                v-show="isSea"
                :disabled="chkMatch"
                filterable
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                :default-value="form.seCarrier == 0 ? '': form.seCarrier"
                @parentCallBack="p=>form.seCarrier=p.cmpIdx"
              />
              <cargo-advance-select
                v-show="!isSea"
                :disabled="chkMatch"
                filterable
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                :default-value="form.aiCarrier == 0 ? '': form.aiCarrier"
                @parentCallBack="p=>form.aiCarrier=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="saleRoleHide" :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_FLCLType')">
              <el-select
                v-model="form.containerLoadType"
                :disabled="chkMatch"
              >
                <el-option
                  v-for="(item,index) in containerLoadTypes"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_CargoType')">
              <cargo-advance-select
                filterable
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_CargoType"
                callback-method-type="value"
                :default-value="form.cargoType"
                :callback-params="{key:'cargoType'}"
                options-width="150px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.PortOfLoading')">
              <cargo-advance-select
                v-show="isSea"
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.txtSeaLoadingPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtSeaLoadingPort=p.code}"
              />
              <cargo-advance-select
                v-show="!isSea"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                options-width="150px;"
                :default-value="form.txtAirLoadingPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtAirLoadingPort=p.code}"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="saleRoleHide" :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
              <cargo-advance-select
                v-show="isSea"
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.txtSeaDestinationPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtSeaDestinationPort=p.code}"
              />
              <cargo-advance-select
                v-show="!isSea"
                :disabled="chkMatch"
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                :default-value="form.txtAirDestinationPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtAirDestinationPort=p.code}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_Airline')">
              <cargo-advance-select
                filterable
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Region"
                :callback-params="{key:'txtServiceLine'}"
                callback-method-type="value"
                options-width="150px;"
                :default-value="form.txtServiceLine"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="job && job.fba" :span="8">
            <el-form-item :label="$t('SeaExport.FeeName')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_ChargeItem"
                :default-value="form.chargeItemId === 0 ? '': form.chargeItemId"
                @parentCallBack="p=>form.chargeItemId=p.itemId"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="source==='tabCharges'" :span="8">
            <el-form-item :label="$t('Pricing.BeginDate')">
              <div style="display: flex;justify-content: space-between">
                <el-date-picker
                  v-model="form.effectiveDateStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                />
                <span style="font-size: 12px;margin-left: 1px;margin-right: 1px;">-</span>
                <el-date-picker
                  v-model="form.effectiveDateEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="saleRoleHide" :gutter="10">
          <el-col v-if="source!=='tabCharges'" :span="8">
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :disabled="chkMatch"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true, active: true}"
                :default-value="form.txtExchangeAgent == 0 ? '': form.txtExchangeAgent"
                @parentCallBack="p=>form.txtExchangeAgent=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="source!=='tabCharges' ? 8 : 0">
            <el-form-item label=" ">
              <div style="display: flex;justify-content: space-between">
                <!-- <el-input-number
                  v-model="form.limit"
                  :min="10"
                  :max="999"
                  controls-position="right"
                  style="width: 60%;"
                /> -->
                <el-checkbox
                  v-show="source !== 'jobList'"
                  v-model="chkMatch"
                  @change="chkMatch_changeHandler"
                >{{ $t('SeaExport.Autowire') }}</el-checkbox>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="custom"
            >
              <el-button
                type="primary"
                @click="toQuery(1)"
              >{{ $t('common.btn.query') }}</el-button>
              <el-button
                type="primary"
                @click="resetHandler"
              >{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="app-main-inner-row row-grid"
      style="min-height:350px;padding:0"
    >
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        config-module="1301011"
        :deselect-sub-record="true"
        style="width:100%;height: 370px;"
        @gridReady="onGridReady"
      />
    </div>
    <div class="pagination-wrapper">
      <cargo-pagination
        config-module="1301011"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="toQuery()"
      />
    </div>
    <span
      slot="footer"
      style="padding:10px"
    >
      <el-button
        type="primary"
        @click="selectHandler"
      >{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import ColumnUtils from '@/utils/ColumnUtils'
import { chargeSchemeSelector } from '@/api/costPlan'
import { insertChargeBatchByScheme } from '@/api/clearing/charge'
import { ErrorTip } from '@/utils/class/ErrorTip'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import { cache } from '@/utils/cacheManager'
import { sortByMultiField } from '@/utils'
import { getLocationList } from '@/api/location'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { CHANGE_CHARGE_CHARGETYPE } from '@/class/cargo/model/parameters/ChangeChargeConstant'

export default {
  name: 'ChargeSchemeBatchDialog',
  components: { CargoAdvanceSelect, CargoSalesCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    selectedJobs: { type: Array, default: () => [] },
    chargeType: { type: Number, default: null }, // chargeType有值时，isCostAddChargeRole、isPayAddChargeRole这两个值 相关判断不生效
    isSea: { type: Boolean, required: true, default: () => false },
    lob: { type: String, required: true, default: () => '' },
    originalCondition: { type: Object, required: true, default: () => {} },
    chargeSchemeIsApproved: { type: Boolean, required: true },
    source: { type: String, default: 'jobList' }, // 窗体打开来源  1.jobList业务列表 费用导入 ; 2.agentBilling 代理分成账单 费用方案 3.tabCharges 费用页签 费用方案 4.addCharge 各业务模块列表新增费用-费用方案
    job: { type: Object, required: false },
    needCheckRange: { type: Boolean, required: false, default: () => true }, // 是否需要使用原区间过滤（true原逻辑）
    location: { type: String, required: false },
    receivable: { type: Number, required: false },
    receivableDisable: { type: Boolean, required: false, default: () => false },
    saleRoleHide: { type: Boolean, default: false } // 子应用销售角色
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      MAX_COUNT: 5000,
      selectTypeNames: TYPE_NAMES,
      CHANGE_CHARGE_CHARGETYPE,
      innerVisible: false,
      neverShow: true, // 从未显示过
      chargeWeightValueType: 0, // 录入费用计费数量取值类型
      title: this.$t('SeaExport.BatchFeeScheme'),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: (data) => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.SchemaName'),
          field: 'name',
          width: 200,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: (params) => {
              return true
            }
          }
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        onRowSelected: this.treeDataRowSelectedCallBack
      },
      containerLoadTypes: ContainerLoadType.CONTAINERLOAD_TYPES,
      form: {
        schemeName: '',
        customer: 0,
        bookingAgent: 0,
        seCarrier: 0,
        aiCarrier: 0,
        containerLoadType: '',
        cargoType: '',
        txtSeaLoadingPort: '',
        txtAirLoadingPort: '',
        txtSeaDestinationPort: '',
        txtAirDestinationPort: '',
        txtDestAgent: '',
        txtServiceLine: '',
        effectiveDateStart: '',
        effectiveDateEnd: '',
        txtNominatedAgent: '',
        txtExchangeAgent: '',
        receivable: '',
        chargeItemId: 0 // 费用名称
        // limit: 30
      },
      pageNum: 1,
      pageSize: 30,
      total: 0,
      cityList: [], // 城市列表
      rowData: [],
      gridApi: null,
      chkMatch: false, // 是否自动匹配
      isSuitEQ: true, // 判断费用方案类型与业务是否匹配
      isCostAddChargeRole: this.$checkPermission(['button_Charge_costAddCharge']), // 应付费用新增权限
      isPayAddChargeRole: this.$checkPermission(['button_Charge_payAddCharge']), // 应收费用新增权限
      addSpecialChargeRole: this.$checkPermission(['button_Charge_addSpecialCharge']) // 特殊费用新增权限
    }
  },
  computed: {
    isRb() { // 是否是铁路业务
      return this.lob === 'RB'
    },
    isJobRb() { // 是否是铁路业务
      return this.job && this.job.lob === 'RE' || this.job.lob === 'RI'
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_PayReceive'),
          field: 'receivable',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PartnerType'),
          field: 'partnerType',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.partnerTypeLabelFunction(params.value, this.lob, this.job.fba)
          },
          width: 140
        },
        {
          headerName: this.$t('SeaExport.Account'),
          field: 'accountId',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.resolveColumnLabel(
              TYPE_NAMES.basic_data_Company,
              'cmpIdx',
              Number(params.value),
              'chineseName'
            )
          },
          width: 140
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          field: 'invoiceTitle',
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'currency',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.MeasureCurrency'),
          field: 'measure',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.measureLabelFunction1(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_RangeAndGE'),
          field: 'rangeGe',
          cellRenderer: (params) => {
            return ColumnUtils.formatNumber(params.value, 0, true)
          },
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RangeAndLT'),
          field: 'rangeLt',
          cellRenderer: (params) => {
            return ColumnUtils.formatNumber(params.value, 0, true)
          },
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerSize'),
          field: 'eqSize',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.eqSizeLabelFun(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerType'),
          field: 'eqType',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.MeasureUnit'),
          field: 'unitStep',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AmountNumber'),
          field: 'quantity',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.returnThreeZeroFormatNumber(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UnitPrice'),
          field: 'unitRate',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.MiniMum'),
          field: 'minimum',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax', field: 'unitPriceIncludeTax', width: 120,
          valueFormatter: (params) => {
            if (!params.data['chargeSchemeUuid']) return ''
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', width: 120,
          valueFormatter: (params) => {
            if (!params.data['chargeSchemeUuid']) return ''
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('Pricing.BelongingCity'),
          field: 'cityCode',
          width: 120,
          hide: true,
          valueFormatter: (params) => {
            if (!params.value) return ''
            const city = this.cityList.find(p => p.code === params.value)
            if (!city) return ''
            return this.$store.getters.language === 'zh' ? city.chineseName : city.englishName
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remark',
          width: 120
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && (this.chargeType !== null || (!this.isCostAddChargeRole && !this.isPayAddChargeRole))) {
        this.$emit('update:visible', false)
        this.$message.info(this.$t('Message.NoPermissionToAddExpense'))
        return
      }
      this.innerVisible = newVal
      // 若页面打开，清空列表 判断是否勾选自动匹配 勾选则重新获取费用方案
      if (newVal) {
        this.rowData = []
        this.pageNum = 1
        this.total = 0
        if (this.chkMatch) {
          this.automaticMatch()
          this.toQuery(1)
        }
      }
    },
    innerVisible(newVal) {
      if (newVal) {
        this.initCondition()
      } else {
        if (this.source === 'agentBilling') {
          LocalStorageUtils.setConfiguration('agentBilling_schemeName', this.form.schemeName)
        }
        this.$emit('update:visible', newVal)
      }
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = this.visible
      this.initCondition()
    }
  },
  methods: {
    treeDataRowSelectedCallBack(p) {
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    getValueFromChild(obj) {
      // if (!obj || !obj.value) return
      this.form[obj.key] = obj.value
    },
    getCargoType() {
      if (this.lob === SystemConstants.SE.code || this.isRb) {
        this.containerLoadTypes = ContainerLoadType.CONTAINERLOAD_TYPES
      } else if (this.lob === SystemConstants.SI.code) {
        this.containerLoadTypes = ImportConstants._cargoTypeInputList
      } else if (this.lob === SystemConstants.AE.code) {
        this.containerLoadTypes = AirExportConstants.BUSINESS_MODELS
      } else if (this.lob === SystemConstants.AI.code) {
        this.containerLoadTypes = ImportConstants._cargoTypeAirInputList
      } else if (this.lob === SystemConstants.IE.code) {
        this.containerLoadTypes = ContainerLoadType.IE_TYPES
      }
    },
    async getCityList() {
      if (!this.cityList || this.cityList.length <= 0) {
        this.cityList = await getLocationList({}).then((res) => {
          return res.data.list || []
        })
      }
    },
    initCondition() {
      this.chargeWeightValueType = ChargeUtils.getChargeWeightValueType(true)
      this.getCargoType()
      if (this.source === 'jobList' || this.source === 'addCharge') {
        this.form.customer = this.originalCondition.customerId
        this.form.seCarrier = this.originalCondition.carrierId
        this.form.aiCarrier = this.originalCondition.carrierId
        this.form.bookingAgent = this.originalCondition.bookingAgent
        this.form.cargoType = !this.originalCondition.cargoType
          ? 'GC'
          : this.originalCondition.cargoType
        this.form.containerLoadType = this.selectedContainerLoadType()
        if (!this.form.containerLoadType && this.job.lob !== 'AI') {
          this.form.containerLoadType = '' // flex中整拼类型的控件默认第一个 / FCL
          if (this.job.lob === 'SE' || this.isJobRb) {
            this.form.containerLoadType = 'FCL'
          }
        }
        this.form.txtSeaLoadingPort = this.originalCondition.loadingPort
        this.form.txtAirLoadingPort = this.originalCondition.loadingPort
        this.form.txtSeaDestinationPort = this.originalCondition.destinationPort
        this.form.txtAirDestinationPort = this.originalCondition.destinationPort
        this.form.txtDestAgent = this.originalCondition.destinationAgent
        this.form.txtServiceLine = this.originalCondition.vesselLine
        this.form.txtNominatedAgent = this.originalCondition.designationAgent
        this.form.txtExchangeAgent = this.originalCondition.exChangeAgent
      } else {
        if (this.source === 'tabCharges') {
          if (this.containerLoadTypes.length > 0) {
            const index = this.containerLoadTypes.findIndex(p => p.code === this.form.containerLoadType)
            if (index < 0) {
              this.form.containerLoadType = this.containerLoadTypes[0].code
            }
          } else {
            this.form.containerLoadType = ''
          }
        }
        if (this.source === 'agentBilling') {
          this.form.containerLoadType = this.selectedContainerLoadType() || ((this.job.lob === 'SE' || this.isJobRb) ? 'FCL' : '') // flex中整拼类型的控件默认第一个 / FCL
          const schemeName = LocalStorageUtils.getConfiguration('agentBilling_schemeName')
          if (schemeName) {
            this.form.schemeName = schemeName
          }
        }
        if (this.source === 'operateBillDialog') {
          this.form.receivable = this.receivable
        }
        this.title = this.$t('FinanceManage.charge_sp7')
        // 判断 是否需要自动匹配
        const isMatch = LocalStorageUtils.getConfiguration('SCHEME_MATCH')
        if (isMatch) {
          this.chkMatch = true
          this.automaticMatch()
          if (this.neverShow) {
            this.toQuery(1)
          }
        }
      }
      this.neverShow = false
      this.getCityList()
    },
    selectedContainerLoadType() {
      let loadType = ''
      if (!this.job) return loadType
      if (
        this.job.lob === 'SE' ||
        this.job.lob === 'SI' ||
        this.isJobRb
      ) {
        loadType = this.job.containerLoadType
      } else {
        loadType = this.job.operateType
      }
      return loadType
    },
    toQuery(pageNum) {
      if (typeof pageNum === 'number') {
        this.pageNum = pageNum
      }
      const map = { pageNum: this.pageNum, pageSize: this.pageSize }
      map['lob'] = this.lob
      if (this.form.schemeName !== '') {
        map['name'] = this.form.schemeName
      }
      if (this.form.customer > 0) {
        map['customerId'] = this.form.customer
      }
      if (this.job.lob !== 'AI') {
        map['wgtValue'] = (this.chargeWeightValueType === 0 ? this.job.weightActual : this.job.weightContract) || 0
        map['wgTxValue'] = (this.job.chargeWeight) || 0
        map['volValue'] = (this.chargeWeightValueType === 0 ? this.job.cubageActual : this.job.cubageContract) || 0
        if (this.job.lob === 'AE') {
          map['wgTxValue'] = (this.job.cWeight) || 0
        }
      } else {
        map['wgtValue'] = (this.job.weightContract) || 0
        map['wgTxValue'] = (this.job.chargeWeight) || 0
        map['volValue'] = (this.job.cubageContract) || 0
      }
      map['needCheckRange'] = this.needCheckRange
      if (this.isSea) {
        if (this.form.seCarrier > 0) {
          map['carrierId'] = this.form.seCarrier
        }
        if (this.form.txtSeaLoadingPort !== '') {
          map['loadingPort'] = this.form.txtSeaLoadingPort
        }
        if (this.form.txtSeaDestinationPort !== '') {
          map['destinationPort'] = this.form.txtSeaDestinationPort
        }
      } else {
        if (this.form.aiCarrier > 0) {
          map['carrierId'] = this.form.aiCarrier
        }
        if (this.form.txtAirLoadingPort !== '') {
          map['loadingPort'] = this.form.txtAirLoadingPort
        }
        if (this.form.txtAirDestinationPort !== '') {
          map['destinationPort'] = this.form.txtAirDestinationPort
        }
      }
      if (this.form.txtDestAgent > 0) {
        map['destAgent'] = this.form.txtDestAgent
      }
      if (this.form.bookingAgent > 0) {
        map['bookingAgent'] = this.form.bookingAgent
      }
      if (this.form.cargoType !== '' && this.form.cargoType !== 'All') {
        map['cargoType'] = this.form.cargoType
      }
      if (this.form.containerLoadType !== '') {
        map['containerLoadType'] = this.form.containerLoadType
      }
      if (this.form.txtServiceLine !== '') {
        map['region'] = this.form.txtServiceLine
      }
      if (this.source !== 'tabCharges') {
        // 费用页签不要过滤当前部门
        map['departmentId'] = this.$store.getters.currentDeptId
      } else {
        map['departmentId'] = 0
      }
      if (this.selectedJobs) {
        map['businessDateList'] = Array.from(
          this.selectedJobs,
          (p) => p.businessDate
        )
      }
      if (this.chargeSchemeIsApproved) {
        map['checkState'] = 1
      }
      map['branchId'] = this.$checkPermission([
        'role_FMChargeScheme_ViewOfficeChargeScheme'
      ])
        ? 0
        : this.$store.getters.currentOfficeId
      // CARGO-30754 兰高13855：费用方案区分分公司
      map['currentBranchId'] = this.$store.getters.currentOfficeId
      // map['limit'] = this.form.limit > 0 ? this.form.limit : 30

      // 代理分成账单 -费用方案
      if (this.source !== 'jobList') {
        let businessDate = null
        if (this.job.lob === 'SE' || this.job.lob === 'AE' || this.job.lob === 'RE') {
          businessDate = this.job.etd
        } else if (this.job.lob === 'SI' || this.job.lob === 'AI' || this.job.lob === 'RI') {
          businessDate = this.job.eta
        }
        if (businessDate) {
          map['businessDate'] = businessDate
        }
        if (this.job.opDepartment !== 0) {
          map['departmentId'] = this.job.opDepartment
        }
        map['jobKey'] = this.job.uuid
      }
      if (this.form.effectiveDateStart) {
        map['effectiveDateStart'] = this.form.effectiveDateStart
      }
      if (this.form.effectiveDateEnd) {
        map['effectiveDateEnd'] = this.form.effectiveDateEnd
      }
      if (this.job && this.job.fba) map['fba'] = this.job.fba
      if (this.form.chargeItemId && this.form.chargeItemId > 0) {
        map['chargeItemId'] = this.form.chargeItemId
      }
      // 串 应收应付
      if (this.chargeType !== null) {
        if ([SystemConstants.CHARGE_TYPE_RADIO_COST.code, SystemConstants.CHARGE_TYPE_RADIO_COST_SPECIAL.code].indexOf(this.chargeType) > -1) {
          map['receivable'] = true
        } else if ([SystemConstants.CHARGE_TYPE_RADIO_PAY.code, SystemConstants.CHARGE_TYPE_RADIO_PAY_SPECIAL.code].indexOf(this.chargeType) > -1) {
          map['receivable'] = false
        }
      }
      if (this.form.txtNominatedAgent > 0) {
        map['designationAgent'] = this.form.txtNominatedAgent
      }
      if (this.form.txtExchangeAgent > 0) {
        map['exChangeAgent'] = this.form.txtExchangeAgent
      }
      if (this.form.receivable !== '') {
        map['receivable'] = this.form.receivable
      }
      this.loading = getLoading4Cxt(this)
      chargeSchemeSelector(map).then((res) =>
        this.chargeSchemeSelectorResult(res)
      ).finally(() => {
        this.loading.close()
      })
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    chargeSchemeSelectorResult(res) {
      const result = res.data.list
      this.rowData = result ? sortByMultiField(result, ['level'], false) : []
      this.pageNum = res.data.pageNum
      this.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      // 全选
      const isMatch = LocalStorageUtils.getConfiguration('SCHEME_MATCH')
      if (isMatch) {
        this.$nextTick(() => {
          this.gridApi.selectAll()
        })
      }
    },
    // 是否自动匹配
    chkMatch_changeHandler() {
      if (this.chkMatch) {
        this.automaticMatch()
        this.toQuery(1)
      }
    },
    automaticMatch() {
      this.form.customer = this.job.customerId
      this.form.seCarrier = this.job.carrierId
      this.form.aiCarrier = this.job.carrierId
      this.form.bookingAgent = this.job.bookingAgent
      this.form.cargoType = !this.job.cargoType ? 'GC' : this.job.cargoType
      this.form.containerLoadType = this.selectedContainerLoadType()
      this.form.txtSeaLoadingPort = this.job.loadingPortCode
      this.form.txtAirLoadingPort = this.job.loadingPortCode
      this.form.txtSeaDestinationPort = this.job.destinationPortCode
      this.form.txtAirDestinationPort = this.job.destinationPortCode
      this.form.txtDestAgent = this.job.destinationAgent
      this.form.txtServiceLine = this.job.vesselLine
      this.form.txtNominatedAgent = this.job.designationAgent
      this.form.txtExchangeAgent = this.job.exChangeAgent
    },
    async selectHandler() {
      if (this.source === 'jobList') {
        const rows = this.gridApi.getSelectedRows().filter(p => p.chargeItemId)
        const jobKeys = Array.from(this.selectedJobs, (p) => p.uuid)
        if (jobKeys.length === 0 || rows.length === 0) {
          throw new ErrorTip(this.$t('Message.PleaseSelect1ChargeDetail'))
        }
        if (jobKeys.length > this.MAX_COUNT) {
          this.$message.warning(
            this.$t('Message.TheNumberOfChargesLimited') + this.MAX_COUNT
          )
          return
        }
        let schemeDetails = []
        for (const item of rows) {
          if (item.chargeSchemeUuid !== '' && item.chargeSchemeUuid !== null) {
            const message = ChargeUtils.checkChargeRateRange(item)
            if (message) {
              this.$message.warning(this.$t('CargoMsg.Cargo_TaxRateRangeLimit', [message]))
              return
            }
            schemeDetails.push(item)
          }
        }
        schemeDetails = await this.getValidSchemeDetails(schemeDetails)
        if (schemeDetails.length === 0) {
          return
        }
        this.loading = getLoading4Cxt(this)
        insertChargeBatchByScheme({
          jobKeys: jobKeys,
          schemeDetails: schemeDetails,
          branchId: this.$store.getters.currentOfficeId,
          needCheckRange: !this.needCheckRange, // 原逻辑是查询时过滤，保存时不过滤。
          location: this.location
        }).then((res) => {
          const count = res.data
          if (count === -1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ImportFailMessage'))
          } else {
            let msg = this.$t('Message.ImportSuccessChargesCount')
            msg = msg.replace('{count}', count)
            this.$message.success(msg)
            this.gridApi.deselectAll()
            this.innerVisible = false
          }
        }).finally(() => {
          this.loading.close()
        })
      } else {
        let schemeDetails = this.getSelectItems()
        if (schemeDetails.length === 0 && this.isSuitEQ) {
          this.$message.info(this.$t('Message.PleaseSelect1ChargeDetail'))
          return
        } else if (schemeDetails.length === 0 && !this.isSuitEQ) {
          this.$message.info(this.$t('Message.CheckCostAndBusinessMismatching'))
          return
        }
        schemeDetails = await this.getValidSchemeDetails(schemeDetails)
        if (schemeDetails.length === 0) {
          return
        }
        LocalStorageUtils.setConfiguration('SCHEME_MATCH', this.chkMatch)

        // 调用父组件方法
        this.$emit('selectedSchemeHandler', schemeDetails)
        this.gridApi.deselectAll()
        this.innerVisible = false
      }
    },

    getSelectItems() {
      // 过滤父级节点
      const rows = this.gridApi.getSelectedRows().filter(p => p.chargeItemId)
      const selectItems = []
      let isSuitEQ_ = false
      for (const schemeDetail of rows) {
        if (this.isSea) {
          if (ChargeUtils.measureIsEq(schemeDetail.measure)) {
            if (ChargeUtils.isEQ(schemeDetail, this.job)) {
              selectItems.push(schemeDetail)
              isSuitEQ_ = true
            }
          } else if (schemeDetail.measure === ChargeMeasure.SONO_MEASURE.code && this.job.manifestInfos) {
            let quantity = 0
            const soNoMap = {}
            for (const man of this.job.manifestInfos) {
              if (man.manifestGoods) {
                for (const goods of man.manifestGoods) {
                  if (goods.soNo && !goods.deleted && !soNoMap[goods.soNo]) {
                    soNoMap[goods.soNo] = true
                    quantity += 1
                  }
                }
              }
            }
            if (quantity > 0) {
              selectItems.push(schemeDetail)
              isSuitEQ_ = true
            }
          } else {
            selectItems.push(schemeDetail)
            isSuitEQ_ = true
          }
        } else {
          selectItems.push(schemeDetail)
        }
      }
      if (this.isSea && !isSuitEQ_) {
        this.isSuitEQ = isSuitEQ_
      }
      return selectItems
    },
    async getValidSchemeDetails(schemeDetails) {
      if (schemeDetails.length === 0 || this.chargeType !== null || (this.isCostAddChargeRole && this.isPayAddChargeRole)) {
        return schemeDetails
      }
      if (!this.isCostAddChargeRole && !this.isPayAddChargeRole && !this.addSpecialChargeRole) {
        this.$message.info(this.$t('Message.NoPermissionToAddExpense'))
        return []
      }

      // 遍历所有费用进行权限校验
      const validDetails = []
      for (const detail of schemeDetails) {
        if (detail.special) {
          // 特殊费用：需要特殊费用新增权限
          if (this.addSpecialChargeRole) {
            validDetails.push(detail)
          } else {
            // 没有特殊费用新增权限，提示并返回空数组
            this.$message.warning('没有特殊费用新增权限')
            return []
          }
        } else {
          // 普通费用：根据应收/应付类型判断对应权限
          if (detail.receivable) {
            // 应收费用：需要应收新增权限
            if (this.isPayAddChargeRole) {
              validDetails.push(detail)
            } else {
              // 没有应收新增权限，提示并返回空数组
              this.$message.warning('没有应收费用新增权限')
              return []
            }
          } else {
            // 应付费用：需要应付新增权限
            if (this.isCostAddChargeRole) {
              validDetails.push(detail)
            } else {
              // 没有应付新增权限，提示并返回空数组
              this.$message.warning('没有应付费用新增权限')
              return []
            }
          }
        }
      }

      return validDetails
    },
    /**
     * 重置条件
     */
    resetHandler() {
      this.form.schemeName = ''
      this.form.customer = 0
      this.form.seCarrier = 0
      this.form.aiCarrier = 0
      this.form.bookingAgent = 0
      this.form.cargoType = ''
      this.form.containerLoadType = ''
      this.form.txtServiceLine = ''
      // cargoType.selectedIndex = 0; //  0是选择全部
      // containerLoadType.selectedIndex = 0; 0是选择第一个
      this.form.containerLoadType = this.containerLoadTypes[0].code // 默认第一个
      // this.form.limit = 30
      this.form.effectiveDateStart = ''
      this.form.effectiveDateEnd = ''
      this.form.txtNominatedAgent = ''
      this.form.txtExchangeAgent = ''
    }
  }
}
</script>
<style lang="scss">
.charge-scheme-batch-dialog {
  label {
    font-size: 12px;
    font-weight: normal;
  }
  .el-select {
    width: 100%;
  }
  .el-loading-mask {
    z-index: 999999 !important;
  }
}
</style>
